import { render, staticRenderFns } from "./MerchantRelationship.vue?vue&type=template&id=ea46b28a&scoped=true&"
import script from "./MerchantRelationship.vue?vue&type=script&lang=js&"
export * from "./MerchantRelationship.vue?vue&type=script&lang=js&"
import style0 from "./MerchantRelationship.vue?vue&type=style&index=0&id=ea46b28a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea46b28a",
  null
  
)

export default component.exports